import '../Loader/Loader.css';

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader" />
    </div>
  );
};

export default Loader;
